import React, { FC, } from 'react';
import '../../../../style/style.scss';
import I18n from '../../../../helpers/i18n';
import { useNavigate } from 'react-router-dom';

interface Props {
    activeTab: string,
    viewModalLogOut?: any
}

const Menu : FC<Props> = (props) => {
  const navigate = useNavigate();

  const navTo = (e: any, page: string) => {
    e.preventDefault();
    navigate(page);
  };


  const navItems = [
    {
      title: I18n.t('ACCOUNT_DASHBOARD'),
      onClick: '/account'
    },
    {
      title: I18n.t('ACCOUNT_PERSONAL'),
      onClick: '/account/personal'
    }
  ];

  return (
    <section className="account">
      <div className="container account-navigation">
        <div className="row justify-content-lg-center gap-2">
          {navItems.map((item: any) => {
            return (
              <div className="col-12 col-lg-3 p-0" key={item.title}>
                <a
                  onClick={(event) => navTo(event, item.onClick)}
                  className={props.activeTab == item.title ? 'nav-block active' : 'nav-block'}
                >
                  {item.title}
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
export default Menu;
